import img1 from "./WhatsApp Image 2022-02-24 at 2.13.39 PM (1).jpeg";
import img2 from "./WhatsApp Image 2022-02-24 at 2.13.39 PM (2).jpeg";
import img3 from "./WhatsApp Image 2022-02-24 at 2.13.39 PM.jpeg";
import img4 from "./WhatsApp Image 2022-02-24 at 2.13.40 PM.jpeg";

const GalleryIcons = [img1, img2, img3, img4];
export default GalleryIcons;
